import 'css-chunksrc/client/scenes/documentCreation/styles.scss';export default {
  "main": "_main_1ulli_1",
  "buttons": "_buttons_1ulli_8"
};